import { render, staticRenderFns } from "./BotaoGestaoLotesPssc.vue?vue&type=template&id=6159cfc3&lang=pug"
import script from "./BotaoGestaoLotesPssc.vue?vue&type=script&lang=js"
export * from "./BotaoGestaoLotesPssc.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports